"use client"

import FilterCheckbox, { type FilterCheckboxProps } from "~/components/ui/FilterCheckbox"

import * as css from "../styles.css"

export function StandardCheckbox({ type, name, value, ...props }: FilterCheckboxProps) {
  if (!value || typeof value !== "string" || !name) return null

  return (
    <FilterCheckbox
      {...props}
      type={type ?? "checkbox"}
      checkmarkActive={null}
      contentClassName={css.checkbox}
      checkmarkActiveClassName={css.checkmarkActive}
      name={name}
      value={value}
      id={value}
    >
      {value}
    </FilterCheckbox>
  )
}
